//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.Electrical.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"HarnessPartOccurrence",1,"Assemblies.Component",0],[0,"PrototypePort",1,"Routing.Port",0],[0,"PrototypePortPartOccurrence",1,"Assemblies.Component",0],[0,"ReferencePort",1,"TaggedObject",0]],[[[],"ClearHarnessData",{},0,0],[[],"DeletePathArrangement",{},0,0],[[],"EstablishPathArrangement",{},0,0],[["point"],"SetPathArrangementOrigin",{},1,0],[["port"],"InitializeBuilderFromArrangedPort",{},1,0]],[]];
SPLM.Routing.Electrical.PathArrangementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.Electrical.PathArrangementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;